import { Button, Input, message, Modal, Rate } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useFormik } from "formik";
import React, { useState } from "react";
import { FlexStartColumn } from "./Layout";
import { AlertText, NormalText } from "./Typography";
import * as yup from "yup";
import { isEqual } from "lodash";
import { tracker } from "../hooks/useAuthenticate";

type Props = {
  onCancel: () => void;
  isVisible: boolean;
  onDone?: () => void;
};
interface ISurveyData {
  satisfaction: number;
  recommendation: number;
  goodAt: string;
  improveAt: string;
  comment: string;
  phone: string;
}

export const SurveyDialog: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const formik = useFormik<ISurveyData>({
    initialValues: {
      satisfaction: -1,
      recommendation: -1,
      goodAt: "",
      improveAt: "",
      comment: "",
      phone: "",
    },
    onSubmit: (values) => {},
    validationSchema: yup.object().shape({
      satisfaction: yup
        .number()
        .positive("يرجى إضافة التقييم")
        .required("يرجى إضافة التقييم"),
      recommendation: yup
        .number()
        .positive("يرجى إضافة التقييم")
        .required("يرجى إضافة التقييم"),
      goodAt: yup.string().required("يرجى تعبئة هذه الخانة"),
      improveAt: yup.string().required("يرجى تعبئة هذه الخانة"),
      comment: yup.string().required("يرجى تعبئة هذه الخانة"),
      phone: yup.string().required("يرجى تعبئة هذه الخانة"),
    }),
  });
  return (
    <Modal
      onCancel={() => {
        props.onCancel();
        if (props.onDone) {
          props.onDone();
        }
      }}
      visible={props.isVisible}
      footer={[
        <Button
          key="send-btn"
          loading={loading}
          type="primary"
          disabled={
            Object.keys(formik.errors).length !== 0 ||
            isEqual(formik.values, formik.initialValues)
          }
          onClick={async () => {
            try {
              const errors = await formik.validateForm();
              if (Object.keys(errors).length) {
                return;
              }
              setLoading(true);
              tracker.capture("survey_support", {
                ...formik.values,
              });
              message.info("Thanks, You are doing a great job !");
              props.onCancel();
            } finally {
              setLoading(false);
              if (props.onDone) {
                props.onDone();
              }
            }
          }}
        >
          إرسال
        </Button>,
      ]}
      title="استبانة المستخدمين"
    >
      <FlexStartColumn>
        <NormalText>ما مدى رضاك عن نظام جولب بشكل عام" </NormalText>
        <Rate
          value={formik.values.satisfaction}
          onChange={(e) => {
            formik.setFieldValue("satisfaction", e);
          }}
          count={10}
        />
        {formik.errors.satisfaction && (
          <AlertText>{formik.errors.satisfaction}</AlertText>
        )}
      </FlexStartColumn>
      <FlexStartColumn>
        <NormalText>ما مدى ترشيحك لنظام جولب للآخرين ?</NormalText>

        <Rate
          value={formik.values.recommendation}
          onChange={(e) => {
            formik.setFieldValue("recommendation", e);
          }}
          count={10}
        />
        {formik.errors.recommendation && (
          <AlertText>{formik.errors.recommendation}</AlertText>
        )}
      </FlexStartColumn>
      <FlexStartColumn>
        <NormalText>
          {" "}
          ما هي الميزة أو المزايا التي تعجبك حالياً في جولب ?{" "}
        </NormalText>
        <TextArea
          name="goodAt"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.goodAt}
          rows={3}
        />
        {formik.touched.goodAt && formik.errors.goodAt && (
          <AlertText>{formik.errors.goodAt}</AlertText>
        )}
      </FlexStartColumn>
      <FlexStartColumn>
        <NormalText>
          ما هي الميزة أو المزايا التي تطمح أن تكون موجودة في جولب?{" "}
        </NormalText>
        <TextArea
          name="improveAt"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.improveAt}
          rows={3}
        />
        {formik.touched.improveAt && formik.errors.improveAt && (
          <AlertText>{formik.errors.improveAt}</AlertText>
        )}
      </FlexStartColumn>

      <FlexStartColumn>
        <NormalText>ملاحظات أخرى </NormalText>
        <TextArea
          name="comment"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.comment}
          rows={3}
        />
        {formik.touched.comment && formik.errors.comment && (
          <AlertText>{formik.errors.comment}</AlertText>
        )}
      </FlexStartColumn>
      <FlexStartColumn>
        <NormalText>هاتف</NormalText>
        <Input
          name="phone"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.phone}
          type="number"
        />
        {formik.touched.phone && formik.errors.phone && (
          <AlertText>{formik.errors.phone}</AlertText>
        )}
      </FlexStartColumn>
    </Modal>
  );
};
